import {
  DatumOrderStatus,
  OrderAuditStatus,
  OrderStatus,
  SubStatusCountOrderStatus,
} from "@ifa/utils";
import type { OrderListItem } from "@ifa/utils";

type InsurerSyncVisibilityOrder = Partial<
  Pick<
    OrderListItem,
    "orderStatus" | "orderSubStatus" | "orderAuditStatus" | "insurerSyncSupported"
  >
> &
  Record<string, unknown>;

const VISIBLE_ORDER_STATUSES = new Set<string>([
  OrderStatus.OrderAudit,
  OrderStatus.ComplianceAudit,
  OrderStatus.Completed,
]);

const VISIBLE_MAIN_STATUSES = new Set<string>([
  DatumOrderStatus.OrderAudit,
  DatumOrderStatus.ComplianceAudit,
  DatumOrderStatus.Completed,
  DatumOrderStatus.ModifyInfo,
]);

const MODIFY_INFO_AUDIT_STATUSES = new Set<string>([
  OrderAuditStatus.PendingModification,
  OrderAuditStatus.PendingConfirmation,
  OrderAuditStatus.ConfirmationPendingReview,
  OrderAuditStatus.PendingModificationRejected,
]);

const MODIFY_INFO_SUB_STATUSES = new Set<string>([
  SubStatusCountOrderStatus.ModifyInfoPending,
  SubStatusCountOrderStatus.PendingConfirmation,
]);

const getStringValue = (
  order: InsurerSyncVisibilityOrder,
  keys: string[],
) => {
  for (const key of keys) {
    const value = order[key];
    if (typeof value === "string" && value) return value;
  }
  return undefined;
};

export function isInsurerSyncActionVisible(
  order: InsurerSyncVisibilityOrder,
) {
  if (order.insurerSyncSupported !== true) return false;

  const orderStatus = getStringValue(order, ["orderStatus"]);
  if (orderStatus && VISIBLE_ORDER_STATUSES.has(orderStatus)) return true;

  const orderMainStatus = getStringValue(order, [
    "orderMainStatus",
    "mainStatus",
    "datumOrderStatus",
  ]);
  if (orderMainStatus && VISIBLE_MAIN_STATUSES.has(orderMainStatus)) {
    return true;
  }

  const orderAuditStatus = getStringValue(order, ["orderAuditStatus"]);
  if (
    orderAuditStatus &&
    MODIFY_INFO_AUDIT_STATUSES.has(orderAuditStatus)
  ) {
    return true;
  }

  const orderSubStatus = getStringValue(order, ["orderSubStatus"]);
  return !!orderSubStatus && MODIFY_INFO_SUB_STATUSES.has(orderSubStatus);
}
